import { isNil } from "client/Misc/utils";

export function formatCalendarLocations(
	locations: readonly string[] | null
): string | null{
	return isNil(locations) || locations.length === 0
		? null
		: locations.join("; ");
}